import SwiperSlider from '../slider-swiper';

class FinishesTable {
    constructor() {
        /**
         * Css-класс для скрытого состояния
         * @type {String}
         */
        this.hideClass = 'is-hidden';

        /**
         * Css-класс для активного состояния
         * @type {String}
         */
        this.activeClass = 'is-active';

        /**
         * Таблица
         * @type {Node}
         */
        this.table = null;
    }

    /**
     * Инициализирует модуль
     * @param {Object} options - параметры
     */
    init(options) {
        this._setElements(options);
        this._initSwiperSlider();
        this._showBodyItems();
    }

    _setElements(options) {
        this.table = options.table;
        this.headItems = Array.from(this.table.querySelectorAll('.j-finishes-comparison-head-item'));
        this.bodyItems = Array.from(this.table.querySelectorAll('.j-finishes-comparison-row-item'));
        this.sliderWrappers = Array.from(this.table.querySelectorAll('.j-swiper-finishes-slider'));
    }

    _initSwiperSlider() {
        this.sliderWrappers.forEach((wrapper) => {
            const sliderWrapper = wrapper.querySelector('.j-slider-slides');
            const arrowLeft = wrapper.querySelector('.j-arrow-left');
            const arrowRight = wrapper.querySelector('.j-arrow-right');
            const temp = wrapper.classList.contains('j-swiper-finishes-slider-first') ? 'firstSlider' : 'secondSlider';
            const temp2 = wrapper.classList.contains('j-swiper-finishes-slider-first') ? 'secondSlider' : 'firstSlider';

            this[temp] = new SwiperSlider({
                item    : sliderWrapper,
                settings: {
                    wrapperClass    : 'j-slider-slides__wrapper',
                    slideClass      : 'j-slider-slides__slide-finishes',
                    slideActiveClass: 'is-active',
                    slideNextClass  : 'is-next',
                    initialSlide    : temp === 'firstSlider' ? 0 : 1,
                    slidesPerView   : 'auto',
                    loop            : false,
                    speed           : 500,
                    navigation      : {
                        prevEl: arrowLeft,
                        nextEl: arrowRight
                    }
                }
            });

            this[temp].init();

            this[temp].slider.on('slideChange', () => {
                setTimeout(() => {
                    const tempIndex = this[temp].slider.activeIndex;
                    const temp2Index = this[temp2].slider.activeIndex;

                    if (temp2Index === tempIndex) {
                        if (temp2Index === (this[temp2].slider.slides.length - 1)) {
                            this[temp2].slider.slideTo(0);
                        } else {
                            this[temp2].slider.slideTo(temp2Index + 1);
                        }
                    }
                    this._hideBodyItems();
                    this._showBodyItems();
                }, 100);
            });
        });
    }

    _showBodyItems() {
        this.headItems.forEach((headItem) => {
            if (headItem.classList.contains(this.activeClass)) {
                this.bodyItems.forEach((bodyItem) => {
                    if (headItem.dataset.name === bodyItem.dataset.name) {
                        bodyItem.classList.remove(this.hideClass);
                        if (headItem.closest('.j-swiper-finishes-slider-first')) {
                            bodyItem.style.order = '-1';
                        }
                    }
                });
            }
        });
    }

    _hideBodyItems() {
        this.bodyItems.forEach((bodyItem) => {
            bodyItem.classList.add(this.hideClass);
            bodyItem.style.order = '0';
        });
    }
}

export default FinishesTable;
